import { useEffect } from "react";
import { useLocation, useSearch } from "wouter";

export function RouteScrollReset() {
  const [location] = useLocation();
  const search = useSearch();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location, search]);
  return null;
}
